<template>
  <nav>
    <v-card flat color="rgba(0,0,0,0)">
      <center>
        <v-avatar class="avatar1" size="130" >
          <v-img
            :src=posted_by.avatar
          ></v-img>
        </v-avatar>
      </center>
    </v-card>
    <v-card class="pt-5 pl-3 pr-3 pb-3 card1">
      <center class="pt-5">
        <h2 class="headline  pt-1 ">{{ posted_by.name }}</h2>
        <span class="font-italic green--text text--darken-1 p1">{{ postUserDetails.email }}</span>
        <br />
        <span class="green--text text--darken-1 p1">+91-{{ postUserDetails.contact }}</span>
        <v-divider class="mt-2"/>
        
        <div class="p1  pt-3">
          
          <span>From:</span>
          <span class="green--text font-weight-bold">&nbsp;{{ source }}</span>
          <br />
          <span>To:</span>
          <span class="green--text font-weight-bold">&nbsp;{{ destination }}</span>
          
          <br />
          <span>Date:</span>
          <span class="green--text font-weight-bold">&nbsp;{{ date }}</span>
          <span>&nbsp; Time:</span>
          <span class="green--text font-weight-bold">&nbsp;{{ time }}</span>
          <br />
          <span>Cab Booked:</span>
          <span class="green--text font-weight-bold">&nbsp;{{ cab_booked ? "Yes" : "No" }}</span>
          <br />
          <span>Co-passengers:</span>
          <span
            class="green--text font-weight-bold"
          >&nbsp;{{ accepted_count }}/{{ accept_limit }}</span>
          <br />
          
        </div>
      </center>
      
    </v-card>
  </nav>
</template>

<script>
import firebase, { functions } from 'firebase';

export default {
    props: {
        source: String,
        destination: String,
        cab_booked: Boolean,
        date: String,
        time: String,
        accept_limit: Number,
        accepted_count: Number,
        posted_by: Object,
        postId: String
    },

    data() {
        return{
          postUserDetails: {}
        }
    },

    methods: {
      addRequest(){
        var newRequests = [], username='', useravatar='', userRequests=[];
        const db = firebase.firestore();
        var vm = this;
        db.collection('users').doc(firebase.auth().currentUser.uid).get()
        .then(function(doc){
          username = doc.data().name;
          useravatar = doc.data().avatar;
          userRequests = doc.data().requested
          userRequests.push(vm.postId)
          db.collection('users').doc(firebase.auth().currentUser.uid).update({
            requested: userRequests
          })
          .then(function(){
            db.collection('posts').doc(vm.postId).get()
            .then(function(postDoc){
              newRequests = postDoc.data().requests;
              newRequests.push({
                uid: firebase.auth().currentUser.uid,
                name: username,
                avatar: useravatar
              })
              db.collection('posts').doc(vm.postId).update({
                requests: newRequests
              })
            })
          })
        })
      }
    },

    computed: {
      
    },

    mounted(){
      const db = firebase.firestore();
      var vm = this;
      db.collection('users').doc(vm.posted_by.uid).get()
      .then(function(doc){
        vm.postUserDetails = {
          uid: doc.id,
          name: doc.data().name,
          avatar: doc.data().avatar,
          email: doc.data().email,
          contact: doc.data().contact
        }
      })
    }
}
</script>

<style>
.avatar1 {
  position: relative;
  z-index: 1;
}
.card1 {
  position: relative;
  bottom: 90px;
  border-radius: 10px;
}
.p1{
  font-size: 18px;
}
</style>